module.exports = (state, action) => {
  const { boxId, unopened } = action.payload
  
  if (boxId !== undefined) {
    state.boxes[boxId].msgunopen = unopened
    return state
  } else {
    throw new Error('Cannot edit box with id: undefined')
  }
}
